import { FileUploadStructureName } from './question-file-upload.model';
import { SigneringStructureName } from './question-signering.model';

export interface QuestionStructure {
  description: string;
  placeholder: string;
  helpText: string;
  questionMarkText: string;
  headLine: string;
}

export const QuestionStructureName = {
  Description: 'description',
  Placeholder: 'placeholder',
  HelpText: 'helpText',
  QuestionMarkText: 'questionMarkText',
  HeadLine: 'headLine',
  Signering: SigneringStructureName,
  FileUpload: FileUploadStructureName,
} as const;
